import React, { useState } from "react";

import SectionHeader from "@cayuse/shared-react.components.section-header";
import PropTypes from "prop-types";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import DashboardTile from "containers/DashboardView/DashboardTile";
import useDictionary from "hooks/useDictionary";

import styles from "./styles.css";


const DashboardView = ({ summary, onTileClick, activeTile, headerButtons, dashboardTopic, dashboardTilesAriaControls }) => {
	const [ focusedTileIndex, setFocusedTileIndex ] = useState(0);

	const dictionary = useDictionary("dashboard");

	const hasSummary = isNonEmptyArray(summary);

	const tiles = summary.map(stat => ({ ...stat, ref: React.createRef() }));

	const checkIsSelected = (title, activeTile) => {
		return activeTile && title.toLowerCase() === activeTile.replaceAll("\"", "").toLowerCase();
	};

	const handleTileKeyPress = event => {
		const tilesCount = tiles.length;

		if (event.key === "ArrowLeft") {
			const last = tilesCount - 1;
			const next = focusedTileIndex - 1;
			handleNextTile(last, next, 0);
		}

		if (event.key === "ArrowRight") {
			const first = 0;
			const next = focusedTileIndex + 1;
			handleNextTile(first, next, tilesCount - 1);
		}
	};

	const handleNextTile = (firstTileInRound, nextTile, lastTileInRound) => {
		const tileToSelect = focusedTileIndex === lastTileInRound ? firstTileInRound : nextTile;

		setFocusedTileIndex(tileToSelect);

		if (tiles[tileToSelect]?.ref?.current) {
			tiles[tileToSelect].ref.current.focus();
		}
	};

	return (
		<div id="view-dashboard-tiles">

			<SectionHeader header={dashboardTopic ? `${dashboardTopic[0].toUpperCase() + dashboardTopic.slice(1)} Dashboard` : dictionary.heading} buttons={headerButtons} />

			<VerticalSpacing>
				<BasePadding>
					{hasSummary &&
						<div className={styles.dashboardTileContainer} aria-label="Dashboard summary items. Use left/right arrows to navigate" role="toolbar" aria-orientation="horizontal" onKeyDown={handleTileKeyPress}>
							{tiles && tiles.length > 0 && tiles.map(({ title, icon, count, description, ref }, index) => (
								<DashboardTile
									key={`dashboard-tile-${title}`}
									ariaControls={dashboardTilesAriaControls}
									icon={icon}
									count={count}
									title={title}
									description={description}
									dashboardTopic={dashboardTopic}
									onClick={() => onTileClick(title)}
									isSelected={checkIsSelected(title, activeTile)}
									tabIndex={focusedTileIndex === index ? 0 : -1}
									ref={ref}
								/>
							))}
						</div>
					}
				</BasePadding>
			</VerticalSpacing>

		</div>
	);
};

DashboardView.propTypes = {
	headerButtons: PropTypes.arrayOf(PropTypes.node),
	summary: PropTypes.array,
	onTileClick: PropTypes.func,
	dashboardTopic: PropTypes.string,
	dashboardTilesAriaControls: PropTypes.string
};

DashboardView.defaultProps = {
	headerButtons: [],
	dashboardTopic: "items"
};

export default DashboardView;
